import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../CommonTemplates/TestimonialCard.scss";
import CommonDrawer from "../drawer/CommonDrawer";
import ProductCard from "../ProductsCard/ProductCard";
import axios from "axios";
import { useSelector } from "react-redux";
import { apiBaseUrl } from "../../config";
import { getDomainInfo } from "../../utils/utils";

const CollectionSlider = ({ collectionDetails }) => {
  const navigate = useNavigate();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  //const [collectionDetails, setCollectionDetails] = useState({})
  const [productsList, setProductsList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [title, setTitle] = useState("");
  const [tag, setTag] = useState("");
  const { userId } = useParams();
  const { isPredefinedDomain, uid } = getDomainInfo(userId);
  const userid = useSelector((state) => state.fetchUser?.user?.id);

  const [totalProductLength, setTotalProductLength] = useState(0);

  const customSort = useSelector((state) => state.fetchUser?.user?.customSort);

  const viewMoreHandler = () => {
    let collectionName = title?.replace(/\s+/g, "");
    navigate(
      isPredefinedDomain
        ? `/${uid}/collectiondetails/${collectionName}`
        : `/collectiondetails/${collectionName}`,
      {
        state: { collectionDetails: collectionDetails },
      }
    );
  };

  const handleOpenDrawer = (product) => {
    setSelectedProduct(product);
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedProduct(null);
  };

  // useEffect(() => {
  //   if(collectionId) {
  //     fetchCollectionInfo();
  //   }
  // },[collectionId])

  // const fetchCollectionInfo = async () => {
  //   await fetchCollectionDetails(collectionId)
  // }

  useEffect(() => {
    fetchProductInfo();
  }, [collectionDetails]);

  const fetchProductInfo = async () => {
    if (collectionDetails) {
      if (collectionDetails?.productIds?.length > 0) {
        const productIds = collectionDetails.productIds;
        setTitle(collectionDetails?.title);
        setTag(collectionDetails?.tag);
        await fetchProductDetails(productIds);
      }
    }
  };

  const fetchProductDetails = async (productIds) => {
    try {
      // Ensure productIds is an array and not empty
      if (!productIds || productIds.length === 0) {
        console.warn("No product IDs provided for fetching product details.");
        return;
      }

      // Extract product IDs from the objects
      const productIdsArray = productIds.map((product) => product.product);

      // Ensure userid is valid
      if (!userid) {
        console.error("User ID is missing. Cannot fetch product details.");
        return;
      }

      const payload = { productIds: productIdsArray, customSort };
      // console.log(
      //   "Fetching Product Details with Payload:",
      //   JSON.stringify(payload, null, 2)
      // );

      // Correct the API endpoint and ensure it matches the backend
      const response = await axios.post(
        `${apiBaseUrl}user/get-product-details/${userid}`,
        payload
      );

      // console.log("API Response Received:", response);

      if (response && response.data) {
        // console.log("Response Data:", response.data);

        if (response.data.products?.length > 0) {
          setProductsList(response.data.products);
          setTotalCount(response.data.products.length);
          setTotalProductLength(response.data.products.length);
        } else {
          console.warn("No products found in response.");
          setProductsList([]);
        }
      } else {
        console.warn("Response data is empty or undefined.");
      }
    } catch (error) {
      console.error(
        "Error fetching product details:",
        error.response?.data || error.message
      );
    }
  };

  // const fetchCollectionDetails = async () => {
  //   try {
  //     const userId = localStorage.getItem('storeid');
  //     if(userId && collectionId) {
  //       const response = await fetch(
  //           `${apiBaseUrl}user/get-seller-collections-details${userid}`
  //       );
  //
  //       const data = await response.json();
  //       setCollectionDetails(data);
  //     }
  //   } catch (error) {
  //     console.log(`error occurred while fetching the collection details ${error}`)
  //   }
  // };

  return (
    totalCount > 0 && (
      <div className="festive-container" id={title.toLowerCase().replace(/['",]/g, '').replace(/[^a-z0-9\s]/g, '').trim().replace(/\s+/g, '_')}>
        <h1 className="collectionheading collectionTitle">{title}</h1>
        <p className="description">{totalCount} Products</p>

        <div className="scroll-container">
          <div className={`cards-wrapper ${totalCount<4?'jcc':''}`}>
            {productsList.slice(0, 5).map((product, index) => (
              <ProductCard
              key={product.id}
              product={product}
              index={index}
              tag={tag}
              onViewMore={viewMoreHandler}
              onOpenDrawer={handleOpenDrawer}
              totalProducts={productsList.length}
            />            
            ))}
          </div>
        </div>

        {/* Drawer Component */}
        <CommonDrawer
          isOpen={isDrawerOpen}
          onClose={handleCloseDrawer}
          product={selectedProduct}
        />
      </div>
    )
  );
};

export default CollectionSlider;
